// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__h4Drs","icon":"Pagination_icon__hy-ix","btn":"Pagination_btn__X9hBN","current":"Pagination_current__zLEDy"};